export default "__VITE_ASSET__Db5cPNrv__"